var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.zh_CN}},[_c('div',{attrs:{"id":"app"}},[_c('keep-alive',[(_vm.$route.meta.title == '考勤汇总')?_c('router-view'):_vm._e()],1),_c('keep-alive',[(_vm.$route.meta.title == '考勤明细')?_c('router-view'):_vm._e()],1),(
        _vm.$route.meta.title !== '考勤明细' && _vm.$route.meta.title !== '考勤汇总'
      )?_c('router-view'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }